module.exports = __webpack_public_path__ + "img/family.a7bfec43.svg";